module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/beer-14d7f5c207f57f081275ab10ea0b8a94.svg";